export const containerTemplates: TableModule = {
    name: "containerTemplates",
    route: "spa.system.containerTemplates",
    columns: [
        {
            name: "image_id",
            mobile: true,
            width: "w-[150px]"
        },
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        },
        {
            name: "created_at",
            sortable: true,
        },
    ],
    filters: [
        {
            name: "id",
            column: "containerTemplates.id",
            type: "numeric"
        },
        {
            name: "name",
            column: "containerTemplates.name",
            type: "string"
        }
    ],
    quickFilters: [],
    tools: [
        {
            name: "containerTemplates.create",
            isCreateAction: true,
            ability: ["create", "containerTemplates"],
        },
    ]
}